import { MAINTENANCE_URLS } from 'constants/urls'

export const MAINTENANCE = MAINTENANCE_URLS.MAINTENANCE
export const ADD_MAINTENANCE_REQUEST = MAINTENANCE_URLS.ADD_MAINTENANCE_REQUEST
export const VIEW_MAINTENANCE_REQUEST =
  MAINTENANCE_URLS.VIEW_MAINTENANCE_REQUEST
export const EDIT_MAINTENANCE_REQUEST =
  MAINTENANCE_URLS.EDIT_MAINTENANCE_REQUEST
export const CUSTOM_FORM = MAINTENANCE_URLS.CUSTOM_FORM
export const EXTERNAL_SURVEY_HOME = MAINTENANCE_URLS.EXTERNAL_SURVEY_HOME
